"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackHelper = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const iris_web_core_1 = require("iris-web-core");
const AgoraConsole_1 = require("../util/AgoraConsole");
class TrackHelper {
    constructor(engine) {
        this._engine = engine;
    }
    play(track, element, config) {
        try {
            if (track.trackMediaType === 'video' && config) {
                track === null || track === void 0 ? void 0 : track.play(element, config);
            }
            else {
                track === null || track === void 0 ? void 0 : track.play(element);
            }
        }
        catch (e) {
            AgoraConsole_1.AgoraConsole.error(e);
            Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
            throw e;
        }
    }
    stop(track) {
        try {
            track === null || track === void 0 ? void 0 : track.stop();
        }
        catch (e) {
            AgoraConsole_1.AgoraConsole.error(e);
            Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
            throw e;
        }
    }
    setEnabled(track, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield (track === null || track === void 0 ? void 0 : track.setEnabled(enabled));
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(e);
                Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
                throw e;
            }
        });
    }
    setMuted(track, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (track === null || track === void 0 ? void 0 : track.enabled) {
                    yield (track === null || track === void 0 ? void 0 : track.setMuted(enabled));
                }
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(e);
                Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
                throw e;
            }
        });
    }
    setDevice(track, deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield (track === null || track === void 0 ? void 0 : track.setDevice(deviceId));
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(e);
                Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
                throw e;
            }
        });
    }
    setPlaybackDevice(track, deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield (track === null || track === void 0 ? void 0 : track.setPlaybackDevice(deviceId));
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(e);
                Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
                throw e;
            }
        });
    }
}
exports.TrackHelper = TrackHelper;
